<template lang="html">
    <div class="create-dynamic" :style="{ height: isAndroid ? 'calc(100vh - 50px)' : `calc(100vh - ${ 50 + safeHeight }px)` }">
        <!-- <h3>发动态</h3> -->
        <Card v-model="loading">
          <div class="menus">
            <button class="cancel" @click="cancel" >取消</button>
            <button class="primary"  @click="submit">发表</button>
          </div>
        </Card>
        <textarea ref="textarea" class="content" v-model="content" autofocus :placeholder="placeholder"></textarea>
        <div class="img-box" v-if="!getDissId">
            <UploadImg v-for="(item, index) of imgs" :class="{ img: true,  square: Object.is(imgs.length, 4)}"  v-model="item.url" :key="item.sort" @removeImg="removeImg(index)" @uploadStart="uploadStart(item)" @uploadSuccess="uploadSuccess(item)"/>
        </div>
        <div class="tags" v-if="!getDissId && tags.length">
          <h4>点亮下方标签以加入话题/活动</h4>
          <div class="tag-box">
            <span v-for="tag of tags" @click="checkedTag(`${tag.id}`)" :class="{ active: `${tag.id}` === tagId }" :key="tag.id"># {{tag.title}}</span>
          </div>
        </div>
        <!-- <SetNickName :show="showSetNickName" @close="showSetNickName = false"/> -->
        <div class="anonymous-box">
          <div class="left">
            <h4>匿名发表</h4>
            <span>开启后发表此条内容将不对外展示昵称和头像</span>
          </div>
          <div @click="changeIsActual" class="right" :style="{'justify-content':(isActual ? 'flex-end' : 'flex-start'), background: (isActual? '#18CC9F' : '#D8D8D8')}">
            <div ></div>
          </div>
        </div>
        <Message v-if="showMessage" @closeModel="closeModel" :label="messageLabel"/>
        <SetNickName :show="showSetNickName" @close="showSetNickName = false"/>
    </div>
</template>
<script>
import { get, post } from '../../../utils/request.js'
import { get as getUser } from '../../../utils/token'
import { isAndroid } from '../../../utils/utils'
import Message from '../../../components/message'
import Card from '../../../components/CardLoading'
import AuthMixis from '../../../minixs/auth'
import { Toast } from 'vant'
import UploadImg from '../../../components/uploadImage'
import dd from 'DD'
export default {
  mixins: [AuthMixis],
  components: {
    UploadImg,
    Message,
    Card
  },
  data () {
    return {
      content: '',
      imgs: [
        {
          sort: 1,
          loading: false,
          url: ''
        }
      ],
      isAndroid: isAndroid(),
      safeHeight: 0,
      placeholder: '这一刻想吐槽的...',
      showMessage: false,
      messageLabel: '不能为空',
      tags: [],
      tagId: 'all',
      isActual: true,
      loading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const query = vm.$route.query
      let title = ''
      if (query.dissId) {
        title = '写留言'
      } else {
        title = '发吐槽'
      }
      if (query.curriculumId && !query.dissId) {
        title = '请留言'
      }
      if (dd.env.platform !== 'notInDingTalk') {
        dd.ready(function () {
          dd.biz.navigation.setTitle({
            title: title
          })
        })
      }
      document.title = title
    })
  },
  mounted () {
    const query = this.$route.query
    if (query.dissId || query.curriculumId) {
      this.placeholder = '回复'
    }
    if (!query.curriculumId && !query.dissId) {
      this.getTags()
    }
    if (query.curriculumId && !query.dissId) {
      this.placeholder = '请写下你的看法'
    }
    if (query.parentNickName) {
      // this.placeholder = `回复${query.parentNickName}：`
      this.placeholder = '回复'
    }
    if (query.parentNickName) {
      // this.placeholder = `回复${query.parentNickName}：`
      this.placeholder = '回复'
    }
    this.$nextTick(() => {
      const text = this.$refs.textarea
      text.focus()
      this.autoTextarea(text)
    })
  },
  methods: {
    removeImg (index) {
      this.imgs.splice(index, 1)
      this.uploadSuccess()
    },
    getTags () {
      const promise = get({
        url: '/diss/tag'
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.tags = detail
        }
      })
    },
    checkedTag (tagId) {
      this.tagId = tagId
    },
    autoTextarea (elem, extra, maxHeight) {
      extra = extra || 0
      const isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window
      const isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera')
      const addEvent = function (type, callback) {
        elem.addEventListener
          ? elem.addEventListener(type, callback, false)
          : elem.attachEvent('on' + type, callback)
      }
      const getStyle = elem.currentStyle ? function (name) {
        const val = elem.currentStyle[name]

        if (name === 'height' && val.search(/px/i) !== 1) {
          const rect = elem.getBoundingClientRect()
          return rect.bottom - rect.top -
                                        parseFloat(getStyle('paddingTop')) -
                                        parseFloat(getStyle('paddingBottom')) + 'px'
        };

        return val
      } : function (name) {
        return getComputedStyle(elem, null)[name]
      }
      const minHeight = parseFloat(getStyle('height'))

      elem.style.resize = 'none'

      const change = function () {
        let scrollTop; let height
        let padding = 0
        const style = elem.style

        if (elem._length === elem.value.length) return
        elem._length = elem.value.length

        if (!isFirefox && !isOpera) {
          padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'))
        };
        scrollTop = document.body.scrollTop || document.documentElement.scrollTop

        elem.style.height = minHeight + 'px'
        if (elem.scrollHeight > minHeight) {
          if (maxHeight && elem.scrollHeight > maxHeight) {
            height = maxHeight - padding
            style.overflowY = 'auto'
          } else {
            height = elem.scrollHeight - padding
            style.overflowY = 'hidden'
          };
          style.height = height + extra + 'px'
          scrollTop += parseInt(style.height) - elem.currHeight
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          elem.currHeight = parseInt(style.height)
        };
      }

      addEvent('propertychange', change)
      addEvent('input', change)
      addEvent('focus', change)
      change()
    },
    cancel () {
      if (this.judgeIsUploadImages) {
        Toast.fail('请等待图片上传完成！')
        return
      }
      this.$router.back()
    },
    changeIsActual () {
      this.isActual = !this.isActual
      let message = '已开启匿名发表'
      if (this.isActual) {
        message = '已开启匿名发表'
      } else {
        message = '已关闭匿名发表'
      }
      Toast(message)
    },
    closeModel () {
      this.showMessage = false
      this.messageLabel = ''
    },
    checkoutSensitiveWords () {
      const { content } = this
      const words = [/郭广昌/, /汪群斌/, /陈启宇/, /徐晓亮/]
      let label = null
      try {
        words.forEach(item => {
          label = item.exec(content)
          if (label) {
            throw new Error(label)
          }
        })
      } catch (e) {
        /* eslint-disable-next-line */
        console.log('e', e)
      }
      return label
    },
    submit () {
      if (this.judgeIsUploadImages) {
        Toast.fail('请等待图片上传完成！')
        return
      }
      if (!this.isActual) {
        const flag = this.judgeUserNickName()
        if (flag) {
          return
        }
      }
      // const label = this.checkoutSensitiveWords()
      // if (label) {
      //   this.showMessage = true
      //   this.messageLabel = `不许出现${label}字段`
      //   return
      // }
      const query = this.$route.query
      if (query.parentNickName) {
        delete query.parentNickName
      }
      const { content } = this
      if (!content.length) {
        this.showMessage = true
        return
      }
      if (query.curriculumId && !query.dissId) { // 专辑一级评论
        this.submitCurriculumMessage()
      } else {
        if (query.dissId) {
          this.submitComment()
        } else {
          this.submitDiss()
        }
      }
    },
    submitCurriculumMessage () {
      this.loading = true
      const { content } = this
      const query = this.$route.query
      const data = {
        content: content.replace(/\n/g, '<br/>'),
        userId: getUser('user').id,
        curriculumId: query.curriculumId
      }
      if (query.imgUrl) {
        data.imgUrl = query.imgUrl
      }
      const promise = post({
        url: '/course/comment',
        data
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.loading = false
          this.$router.back()
        }
      })
    },
    submitDiss () {
      this.loading = true
      const { content, imgs, tags } = this
      const _tags = tags.filter(item => `${item.id}` === this.tagId).map(item => item.id)
      const data = {
        content: content.replace(/\n/g, '<br/>'),
        images: imgs,
        tags: _tags,
        userId: getUser('user').id,
        isActual: this.isActual
      }
      const promise = post({
        url: '/diss/diss',
        data
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.loading = false
          this.$router.back()
        }
      })
    },
    submitComment () {
      this.loading = true
      const { content } = this
      const query = this.$route.query
      const promise = post({
        url: '/diss/comment',
        data: {
          content: content.replace(/\n/g, '<br/>'),
          userId: getUser('user').id,
          isActual: this.isActual,
          ...query
        }
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.loading = false
          this.$router.back()
        }
      })
    },
    uploadStart (item) {
      item.loading = true
    },
    uploadSuccess (item) {
      item.loading = false
      const { imgs } = this
      // 此处用于修正图片的序号
      imgs.forEach((item, index) => {
        item.sort = index + 1
      })
      if (imgs.length > 8) {
        return
      }
      const filter = imgs.filter(item => !item.url)
      if (filter.length) {
        return
      }
      imgs.push({
        sort: imgs.length + 1,
        loading: false,
        url: ''
      })
    }
  },
  computed: {
    getDissId () {
      return this.$route.query.dissId || this.$route.query.curriculumId
    },
    judgeIsUploadImages () {
      const { imgs } = this
      const some = imgs.some(item => item.loading)
      return some
    }
  }
}
</script>
<style lang="scss" scoped>
.create-dynamic {
    height: 100vh;
    background: #fff;
    h3 {
        font-size:17px;
        font-family:SFProText-Semibold,SFProText;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:22px;
        text-align: center;
        padding: 13px 4.27vw;
    }
    .menus {
        box-sizing: border-box;
        padding: 8px 0;
        display: flex;
        justify-content: space-between;
        width: 95.46vw;
        margin: 0 auto;
        background: #fff;
        button {
            font-size:17px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(0,0,0,1);
            line-height:24px;
            border-radius:4px;
            width: 56px;
            height: 32px;
            box-sizing: border-box;
            text-align: center;
            display: inline-block;
            background: #fff;
            border: none;
        }
        .primary {
            color: #fff;
            background: #18CC9F;
        }
    }
    .content {
        -webkit-tap-highlight-color: rgba(255,0,0,0);
        box-sizing: border-box;
        width: 100%;
        padding: 0 8.52vw;
        border: none;
        outline: none;
        margin-bottom: 16px;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        line-height:24px;
        min-height: 72px;
        margin-top: 32px;
        max-height: 200px !important;
        overflow: scroll !important;;
        &::-webkit-input-placeholder {
          color:rgba(204,204,204,1);
        }
    }
    .img-box {
        padding-left: 8.52vw;
        .square:nth-child(2n){
          margin-right: 30%;
        }
        .square:nth-child(2n + 1){
          margin-right: 1.33vw !important;
        }
        .last {
            position: relative;
        }
        .img:nth-child(3n) {
            margin-right: 0;
        }
    }
    .tags {
      margin: 9.5px 8.52vw;;
      h4 {
       height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:20px;
      }
      .tag-box {
        margin-top: 13px;
        span {
          height:24px;
          font-size:17px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(204,204,204,1);
          height:32px;
          background:rgba(245,245,245,1);
          border-radius:4px;
          margin-right: 12px;
          display: inline-block;
          padding: 4px 8px;
          box-sizing: border-box;
          margin-bottom: 6px;
        }
        .active {
          color: #18CC9F;
          background: #ECFDF9;
        }
      }
    }
    .anonymous-box {
      margin: 0 auto;
      margin-top: 22px;
      width: calc(100% - 48px);
      height: 58px;
      background: #FFFFFF;
      padding: 10px 0;
      border-top: 1px solid #F2F2F7;
      border-bottom: 1px solid #F2F2F7;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: column;
        h4 {
          font-size: 17px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #888888;
          line-height: 18px;
        }
      }
      .right {
        width: 51px;
        height: 31px;
        box-sizing: border-box;
        border-radius: 15.5px;
        position: relative;
        display: flex;
        align-items: center;
        padding: 2px;
        div{
          width: 27px;
          height: 27px;
          border-radius: 50%;
          background: #FFFFFF;
          box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.06), 0px 3px 8px 0px rgba(0, 0, 0, 0.15);
        }
      }
    }
}

</style>
